import Evt from './utils/event'

const Bus = new Evt()

document.addEventListener('mousemove', e => Bus.emit('mousemove', e), false)
document.addEventListener('mouseup', e => Bus.emit('mouseup', e), false)
document.addEventListener('click', e => Bus.emit('click', e), false)
document.addEventListener('keyup', e => Bus.emit('keyup', e), false)

export default Bus
